<template>
  <el-dialog
    :close-on-click-modal="false"
    title="合同"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        :disabled="originData.loadState!==1 && originData.loadState!==4"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false" v-show="!originData.contractUrl">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading"
                 v-if="(originData.loadState === 1 || originData.loadState === 4)"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  orderReceiptUploadContract,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '合同',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            // fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: { // 表单验证规则
          file: [ // 合同
            { required: true, message: '请上传合同', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.originData = item;
        if (item.contractUrl) { // 查看
          this.type = 'detail';
          this.$refs.customForm.setVal('file', [{
            id: item.contractId,
            url: item.contractUrl,
          }]);
        } else { // 新增
          this.type = 'edit';
        }
      });
    },

    customFormPost () {
      // if (this.originData.contractUrl) {
      //   this.dialogFormVisible = false;
      //   return;
      // }
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await orderReceiptUploadContract({
        orderId: this.originData.orderId,
        loadPicIds: form.file[0].id,
        loadUrl: form.file[0].url,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
